import { AfterViewInit, ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Form, FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RoleEnum } from '@core/models/role';
import { MessageService } from '@core/services/message.service';
import { MovimentacaoSocietariaService } from '@core/services/movimentacao-societaria.service';
import { ColumnOrder } from '@core/table/order';
import { JustificativaModalComponent } from '@modules/entidade/pages/justificativa-modal/justificativa-modal.component';
import { MovimentacaoSocietariaExportarModalComponent } from '@modules/movimentacao-societaria/components/movimentacao-societaria-exportar-modal/movimentacao-societaria-exportar-modal.component';
import { MovimentacaoSocietariaHistoricoExportModalComponent } from '@modules/movimentacao-societaria/components/movimentacao-societaria-historico-export-modal/movimentacao-societaria-historico-export-modal.component';
import { PaginationComponent } from '@shared/components/pagination/pagination.component';
import { dataComDigitacao } from '@shared/util/util';
import { NzButtonSize } from 'ng-zorro-antd/button';
import { ModalOptions, NzModalService } from 'ng-zorro-antd/modal';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-movimentacao-societaria-list',
  templateUrl: './movimentacao-societaria-list.component.html',
  styleUrls: ['./movimentacao-societaria-list.component.scss']
})
export class MovimentacaoSocietariaListComponent implements OnInit, AfterViewInit {

  dataSet: any[] = [];
  @ViewChild(PaginationComponent)
  paginator!: PaginationComponent;
  columOrder: ColumnOrder | undefined;

  movimentacaoSocietariaFilterForm!: FormGroup;
  filtro: any;
  roleEnum = RoleEnum;
  statusLista: any[] = [];
  tipoMudancaLista: any[] = [];
  size: NzButtonSize = 'large';

  @HostListener('document:keydown.enter', ['$event'])
  handleEnterKey(event: KeyboardEvent): void {
    event.preventDefault();
    this.pesquisar();
  }

  constructor(
    private fb: FormBuilder,
    private router: Router,
    public route: ActivatedRoute,
    private modalService: NzModalService,
    private cdr: ChangeDetectorRef,
    private movimentacaoSocietariaService: MovimentacaoSocietariaService,
    private changeDetector: ChangeDetectorRef,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.construirForm();
    this.carregarListas();
  }

  ngAfterViewInit(): void {
    this.changeDetector.detectChanges();

    this.paginator.change.subscribe(() => {
      this.consultar();
    });

    this.consultar();
  }

  construirForm() {
    this.movimentacaoSocietariaFilterForm = this.fb.group({
      statusMudancaEntidade: [''],
      nomeParticipantes: [''],
      cnpj:[''],
      tipoMudancaEntidade: [''],
      dataDe: [''],
      dataAte: ['']
    })
    this.cdr.detectChanges();
  }

  carregarListas() {
    forkJoin({
      statusMudanca: this.movimentacaoSocietariaService.statusMudancaEntidade(),
      tipoMudanca: this.movimentacaoSocietariaService.tipoMudancaEntidade()
    }).subscribe(({ statusMudanca, tipoMudanca }) => {
      this.statusLista = statusMudanca.slice(0, 2);
      this.tipoMudancaLista = tipoMudanca;
    });
  }


  pesquisar(): void {
  const formValue = this.movimentacaoSocietariaFilterForm.value;

  this.filtro = Object.fromEntries(
    Object.entries(formValue).filter(([_, value]) => value !== null && value !== '')
  );

  this.paginator.reset();
  this.consultar();
}

  consultar(): void {
    this.movimentacaoSocietariaService.consultarSort(
      this.filtro,
      this.paginator.pagination,
      this.columOrder || {}
    ).subscribe((data) => {
      this.dataSet = data.content;
      this.paginator.totalItens = data.totalElements;
      this.cdr.detectChanges();
    });
  }

  resetForm() {
    this.movimentacaoSocietariaFilterForm.reset();
    this.pesquisar();
  }

  sort(event: any) {
    const itemSelected = event.sort.find((x: any) => x.value);
    if (itemSelected) {
      this.columOrder = { sortField: itemSelected.key, sortOrder: itemSelected.value };
      this.consultar();
    }
  }

  exportarModal(obj?: any): void {
    const config: ModalOptions<MovimentacaoSocietariaExportarModalComponent> = {
      nzContent: MovimentacaoSocietariaExportarModalComponent,
      nzCentered: true,
      nzFooter: null,
      nzMaskClosable: false,
      nzWidth: '20vw',
      nzClosable: false
    };

    const modalRef = this.modalService.create(config);
    modalRef.componentInstance!.documentoId = obj.id;
  }

  abrirExportarHistoricoModal(): void {
    const config: ModalOptions<MovimentacaoSocietariaHistoricoExportModalComponent> = {
      nzContent: MovimentacaoSocietariaHistoricoExportModalComponent,
      nzTitle: 'Exportar Relatório de Histórico',
      nzCentered: true,
      nzFooter: null,
      nzMaskClosable: false,
      nzWidth: '35vw'
    };

    this.modalService.create(config);
  }

  incluirMovimentacaoSocietaria() {
    this.router.navigate([`/movimentacao-societaria/mudanca-societaria/inserir`]);
  }

  editarMovimentacaoSocietaria(obj?: any) {
    // this.router.navigate([`/movimentacao-societaria/natureza-mudanca/editar/${obj.id}`]);
    this.router.navigate([`/movimentacao-societaria/mudanca-societaria/editar/${obj.id}`]);
  }




  onInputDateChange(inputValue: any, campo: string): void {
    dataComDigitacao(inputValue, this.movimentacaoSocietariaFilterForm, campo);
  }
}
